/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import {
    optionSelectMessageFormatter,
    optionSelectInputId,
} from 'ui-sitepass/src/components/errorHandling/messageUtils';

const formatError = (errorMessage, passType) => {
    const split = errorMessage.split(': ');
    let header = '';
    let message = errorMessage;
    if (split.length === 3) {
        header = split[1];
        message = `: ${split[2]}`;
    }
    if (split.length === 2) {
        message = split[1];
    }
    if (message.includes('option-select')) {
        const optSelectMsg = optionSelectMessageFormatter(errorMessage, passType);
        if (optSelectMsg !== null) {
            return optSelectMsg;
        }
    }
    return `${header}${message}`;
};

const inputId = (displayNumber, field, passType) => {
    if (field.includes('First Name')) {
        return `holder-first-name-${displayNumber}`;
    }
    if (field.includes('Last Name')) {
        return `holder-last-name-${displayNumber}`;
    }
    if (field.includes('Email Confirmation')) {
        return `holder-email-confirmation-${displayNumber}`;
    }
    if (field.includes('Email')) {
        return `holder-email-${displayNumber}`;
    }
    if (field.includes('personal-vehicle')) {
        return `vehicle-license-${displayNumber}`;
    }
    if (field.includes('motorized-boat')) {
        return `watercraft-license-${displayNumber}`;
    }
    if (field.includes('start-date')) {
        return `start-date-${displayNumber}`;
    }
    if (field.includes('option-select')) {
        return optionSelectInputId(displayNumber, field, passType);
    }
    if (field.includes('attendee')) {
        const el = document.querySelector('.attendee-info-form input');
        return el?.id || '';
    }
    if (field.includes('Zip Code')) {
        return `holder-zip-code-${displayNumber}`;
    }
    if (field.includes('non_resident_selector')) {
        return `non_resident_selector_${displayNumber}`;
    }
    return `${displayNumber}`;
};

export const errorObject = (error, displayNumber, passType) => {
    return {
        inputId: inputId(displayNumber, error, passType),
        errorText: formatError(error, passType),
    };
};

export const errorSectionHeader = (displayNumber, displayName) => {
    return `${displayNumber}. ${displayName?.toUpperCase()}`;
};
